import React from "react";

export const PermissionIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.66667 2H13.3333C13.7015 2 14 2.29848 14 2.66667V13.3333C14 13.7015 13.7015 14 13.3333 14H2.66667C2.29848 14 2 13.7015 2 13.3333V2.66667C2 2.29848 2.29848 2 2.66667 2ZM3.33333 3.33333V12.6667H12.6667V3.33333H3.33333ZM7.33507 10.6667L4.50666 7.83827L5.44947 6.8954L7.33507 8.78107L11.1063 5.00981L12.0491 5.95262L7.33507 10.6667Z"
        fill="currentColor"
      />
    </svg>
  );
};
